import { Link } from "react-router-dom";
import {
  Paintbrush, Home, Building2, Briefcase, DoorOpen, PaintRoller, ArrowUpToLine,
  PanelBottom, Fence, Layers, Hammer, KeyRound, Building, Store, Palette, ArrowRight,
} from "lucide-react";
import { images } from "@/config/site";

export const serviceIcons = {
  Paintbrush, Home, Building2, Briefcase, DoorOpen, Roller: PaintRoller, ArrowUpToLine,
  PanelBottom, Fence, Layers, Hammer, KeyRound, Buildings: Building, Store, Palette,
};

export function ServiceCard({ service, withImage = true }) {
  const Icon = serviceIcons[service.icon] || Paintbrush;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="tilt-card group flex h-full flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-ember/40 hover:shadow-xl focus-visible:outline focus-visible:outline-2 focus-visible:outline-ember"
    >
      {withImage && (
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={images[service.image].url}
            alt={images[service.image].alt}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      )}
      <div className="flex flex-1 flex-col p-6">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-ember/10 text-ember">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
        <h3 className="mt-4 font-display text-xl font-semibold tracking-tight text-slate-900">{service.name}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{service.short}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-ember-dark transition-colors duration-200 group-hover:text-ember">
          Learn more <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
}
